import styled from 'styled-components';
import React from "react";
import AdUnit from "../feed_inserts/ad_unit";
import useHost from "../../utils/host";
import {useLoggedIn} from "../../store";

export const UnderPostAdUnit = styled(({className, community, postAdTier = 2, ... props}) => {

    const host = useHost();
    const loggedIn = useLoggedIn();

 /*   if (!loggedIn && postAdTier === 1 && (host === "scored.co" || host === "m.scored.co" ||
    host === "communities.win" || host === "m.communities.win")) {

        return (
            <AdsenseUnderPost />
        );

    }*/

    return <AdUnit postPage {...props} />

})``;

export default UnderPostAdUnit;
